import { House } from "lucide-react";
import { Link } from "react-router-dom";

import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";

/**
 * Persistent way back to the dashboard-first home (`/dashboard`) from
 * inside any module's own shell — Sales's `Topbar` and the Global shell's
 * `Topbar` both render this.
 *
 * A house, named "Home" like the module switcher's row for the same page
 * (AB#8921). It was a grid icon, which on the dashboard itself meant "browse
 * modules", so one glyph pointed two ways.
 */
export function LauncherEntryButton() {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Link
          to="/dashboard"
          aria-label="Home"
          className="flex h-9 w-9 items-center justify-center rounded-md text-muted-foreground transition-colors hover:bg-row-hover hover:text-foreground"
        >
          <House size={17} strokeWidth={1.75} />
        </Link>
      </TooltipTrigger>
      <TooltipContent side="bottom">Home</TooltipContent>
    </Tooltip>
  );
}
